import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

type PriceFilterSource = IOfferListLatestQuery | SearchFormValuesType;

export const hasPriceFilter = (source: PriceFilterSource) => {
    const upper = "price_1" in source ? source?.price_1 : source?.price?.upper;
    const lower = "price_0" in source ? source?.price_0 : source?.price?.lower;

    return Number(upper) > 0 || Number(lower) > 0 || Number(source?.instalment) > 0;
};
import {SearchFormValuesType} from "../../../search/types/SearchFormValuesType";
import {IOfferListLatestQuery} from "../types/IOfferListLatestQuery";

type PriceFilterSource = IOfferListLatestQuery | SearchFormValuesType;

export const hasPriceFilter = (source: PriceFilterSource) => {
    const upper = "price_1" in source ? source?.price_1 : source?.price?.upper;
    const lower = "price_0" in source ? source?.price_0 : source?.price?.lower;

    return Number(upper) > 0 || Number(lower) > 0 || Number(source?.instalment) > 0;
};
